/**
 * Экранирует HTML и превращает http(s) URL в кликабельные ссылки (новая вкладка).
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

const urlRe = /https?:\/\/[^\s<]+[^\s<.,;:!?'")\]}>]/gi

export function linkifyText(text: string): string {
  const parts: string[] = []
  let lastIndex = 0
  const re = new RegExp(urlRe.source, urlRe.flags)
  let match: RegExpExecArray | null
  while ((match = re.exec(text)) !== null) {
    parts.push(escapeHtml(text.slice(lastIndex, match.index)))
    const url = match[0]
    const safe = escapeHtml(url)
    parts.push(
      `<a href="${safe}" target="_blank" rel="noopener noreferrer" class="underline break-all">${safe}</a>`,
    )
    lastIndex = match.index + url.length
  }
  parts.push(escapeHtml(text.slice(lastIndex)))
  return parts.join('')
}
